
<app-common-header></app-common-header>
<br />
<br />
<div class="container">
    <div class="row">
        <div class="col-md-9">
            <h1>{{pageheadername}}</h1>
            <br />
            <h4  class="pageheading3 {{this.pageheadername.indexOf('Edit') > -1 ? 'username' :'' }}  {{this.Status == 'Archived' ? 'pending' : this.Status == 'Active' ? 'active' : this.Status == 'Suspended' ? 'suspend' :'inactive' }}" style="text-transform:capitalize;line-height: 1;">
              {{this.Status}}
            </h4>
        </div>
          
    </div>
    <div class="row">
        <div class="col-md-12">
            <form (ngSubmit)="AddEditAffilations(managerMaintenanceForm.value)" [formGroup]="managerMaintenanceForm" role="form" novalidate autocomplete="false">
              <div class="row mt-3">
                <!-- <div class="col-md-6">
                  <label for="userId" class="control-label">ProviderCloudLogo</label>
                  <input
                    type="file"
                    class="form-control"
                    formControlName="uploadedImage"
                    (change)="fileSelecte($event)"
                    #UploadFileInput
                  />
                </div> -->
                <div class="col-md-6">
                  <label for="userId" class="control-label">Affiliate Name</label>
                  <input type="text" (focusout)="Generatelink()" class="form-control" id="AffiliateName" formControlName="AffiliateName" />
                  <mat-error *ngFor="let validation of account_validation_messages.AffiliateName">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('AffiliateName').hasError(validation.type) && (managerMaintenanceForm.get('AffiliateName').dirty || managerMaintenanceForm.get('AffiliateName').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
                <div class="col-md-6">
                  <label for="userId" class="control-label">Contact Person</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="ContactPerson"
                  />
                  <mat-error *ngFor="let validation of account_validation_messages.ContactPerson">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('ContactPerson').hasError(validation.type) && (managerMaintenanceForm.get('ContactPerson').dirty || managerMaintenanceForm.get('ContactPerson').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
              </div>
          
              <div class="row mt-3">
                <div class="col-md-6">
                  <label for="userId" class="control-label">Email</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="Email"
                    (keydown.space)="$event.preventDefault()"
                  />
             
                  <mat-error *ngFor="let validation of account_validation_messages.Email">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('Email').hasError(validation.type) && (managerMaintenanceForm.get('Email').dirty || managerMaintenanceForm.get('Email').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
                <div class="col-md-6">
                  <label for="userId" class="control-label">Phone</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="Phone"
                    id="Phone"
                    (keydown.space)="$event.preventDefault()"
                  
                  />
                  <mat-error *ngFor="let validation of account_validation_messages.Phone">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('Phone').hasError(validation.type) && (managerMaintenanceForm.get('Phone').dirty || managerMaintenanceForm.get('Phone').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <label for="userId" class="control-label">Address</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="Address"
                  />
                  <mat-error *ngFor="let validation of account_validation_messages.Address">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('Address').hasError(validation.type) && (managerMaintenanceForm.get('Address').dirty || managerMaintenanceForm.get('Address').touched)">{{validation.message}}</mat-error>
                  </mat-error>
                </div>
             
                <div class="col-md-6">
                  <label for="userId" class="control-label">Affiliate Link</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="AffiliateLink"
                    readonly
                    disabled="disabled"
                  />
                  <mat-error *ngFor="let validation of account_validation_messages.AffiliateLink">
                    <mat-error class="error-message" *ngIf="managerMaintenanceForm.get('AffiliateLink').hasError(validation.type) && (managerMaintenanceForm.get('AffiliateLink').dirty || managerMaintenanceForm.get('AffiliateLink').touched)">{{validation.message}}</mat-error>
                  </mat-error>

                  <a style="margin-top: -34px;" title="Affiliate Link" data-toggle="tooltip" data-placement="top" title="Copied!" class="pull-right"(click)="copyText()"> <img class="" style="cursor: pointer ;background: #0fd873;  display: inline-block;
                    background: #2191fb;
                    text-align: center;
                    border-radius: 50%;
                    width: 32px;
                    height: 32px;
                    padding: 4px;
                  
                    cursor: pointer;" src="assets/images/link-icon.svg" /></a>
                </div>
              </div>
           
              <div class="pull-right mt-2">
                <!-- <button
                  class="mr-2 mt-0 btn sectbtn brdrRadius"
                  (click)="AddEditAffilations()"
                >
                  Save
                </button> -->
                <button type="submit"  [disabled]="!managerMaintenanceForm.valid" class="mr-2 mt-0 btn sectbtn brdrRadius " >Save</button>

              </div>
            </form>
            <!-- <input matInput [(ngModel)]="data.animal"> -->
        </div>
    </div>
</div>
<ng-template #SuccessModel>
  <div class="modal-header py-0 px-1 pt-1">
    <div class="col-12 text-right py-0 px-0">
      <!-- <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button> -->
      <h4
      class="utility-modal-title font20 text-center text-uppercase"
    
    >
    {{title}}
    </h4> 
   
    </div>
  </div>
  <div class="modal-body pt-0" style="text-align: center;">

    <p class="utility-sub-title font20">
    {{msg}}
    </p>
   
    <button type="button"  class="mr-2 mt-0 btn sectbtn brdrRadius "(click)="modalRef.hide()" >OK</button>

  </div>
</ng-template>


  
  
